import { type Tab, TabSelect } from '@/shared/components/TabSelect';

export const TimeframeTabSelect = <T extends Tab<number>>({
  selected,
  onChange,
  timeframeTabs,
  pillHeight = 26,
  pillWidth = 36,
}: {
  selected: T;
  onChange: (option: T) => void;
  timeframeTabs: T[];
  pillHeight?: number;
  pillWidth?: number;
}) => (
  <TabSelect
    tabs={timeframeTabs}
    onSelectionChange={onChange}
    selectedTab={selected}
    pillWidth={pillWidth}
    pillHeight={pillHeight}
    containerMargin={2}
    btnClasses="text-12 flex justify-center items-center"
  />
);
